import {NgModule} from '@angular/core';
import {StickyContainerComponent} from './sticky-container.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [
        StickyContainerComponent,
    ],
    exports: [
        StickyContainerComponent,
    ],
    imports: [
        CommonModule,
    ]
})
export class StickyContainerModule {
}
